/**
 * @copyright Copyright (c) 2015, Pacific Biosciences of California, Inc.
 * @author <a href="mailto:bskinner@pacificbiosciences.com">Brian Skinner</a>
 */


import { SchemaPropertyMap } from "../utils/legacy/i-schema-property"
import { Endpoint } from "../utils/legacy/endpoint"

export interface IFrame {
    endpoint?: Endpoint
    endpointFunction?: (args: any) => Endpoint
    properties: SchemaPropertyMap
    isCachable?: boolean
}

export class Frame implements IFrame {
    public endpoint: Endpoint
    public properties: SchemaPropertyMap
    public endpointFunction: (args: any) => Endpoint
    public isCachable = false

    constructor(facet: IFrame) {
        this.endpoint = facet.endpoint
        this.properties = facet.properties
        this.endpointFunction = facet.endpointFunction
        this.isCachable = facet.isCachable
    }

    public registerOnClickForProperty(property: string, onClick: (event: any, id: string) => void) {
        if (this.properties[property]) {
            this.properties[property].onClick = onClick
        } else {
            throw new Error("ERROR: Frame.attachCallbackToProperty was called with unknown property: " + property)
        }
    }
}
